import React from 'react';
import { CircularProgress } from '@mui/material';

import { type FilesViewerProps } from '../FilesViewer';
import useSettings from '../../hooks/useSettings';

/** This component can play an audio track */
export default function AudioViewer({ fileEncoded, fileType }: FilesViewerProps) {
	const { t } = useSettings();

	const [isLoading, setIsLoading] = React.useState(false);

	function handleCanPlay() {
		setIsLoading(false);
	}

	return isLoading ? (
		<CircularProgress disableShrink />
	) : (
		<audio
			className="w-full"
			src={`data:audio/${fileType};base64,${fileEncoded}`}
			controls
			onCanPlay={handleCanPlay}
		>
			{t('ERROR_FILE_AUDIO_NOT_SUPPORTED')}
		</audio>
	);
}
